import { buildQueryString } from "../../../helpers/buildQueryString";
import { publicRequest } from "../../../requestMeth";
import {
  dataStart,
  dataSuccess,
  dataFailure,
  measurementGroupsSuccess,
} from "../../reducers/data/dataRedux";

const pad = (n) => (n < 10 ? `0${n}` : n);
const formatDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

const toArgentinaDayRangeUTC = (startD, endD) => {
  if (!startD) return { startDateTime: undefined, endDateTime: undefined };

  const s = new Date(startD);
  const e = endD ? new Date(endD) : new Date(startD);

  const startLocal = new Date(
    s.getFullYear(),
    s.getMonth(),
    s.getDate(),
    0,
    0,
    0,
    0
  );

  const endLocal = new Date(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    23,
    59,
    59,
    999
  );

  return {
    startDateTime: startLocal.toISOString(),
    endDateTime: endLocal.toISOString(),
  };
};

const fetchData = async (
  dispatch,
  token,
  endpoint,
  start,
  end,
  frec,
  mac,
  extra = {},
  id_slave,
) => {
  dispatch(dataStart());

  try {
    const toValidDate = (v) => {
      if (!v) return null;
      const d = v instanceof Date ? v : new Date(v);
      return Number.isNaN(d.getTime()) ? null : d;
    };

    const startD = toValidDate(start);
    const endD = toValidDate(end);
    const hasRange = Boolean(startD && endD);
    const hasFrec =
      frec !== undefined && frec !== null && String(frec).trim() !== "";
    const frecParam = hasFrec ? String(frec).trim() : undefined;
    const startFormat = startD ? formatDate(startD) : undefined;
    const { startDateTime, endDateTime } = toArgentinaDayRangeUTC(startD, endD);
    const endFormatPlus1 =
      endD ? formatDate(addDays(endD, 1)) : undefined;

    let queryObj;

    if (hasFrec) {
      queryObj = {
        startDate: startFormat,
        endDate: endFormatPlus1,
        day: undefined,
        frec: frecParam,
        mac,
        meter: id_slave,
        ...extra,
      };
    } else {
      queryObj = {
        startDate: hasRange ? startFormat : undefined,
        endDate: hasRange ? endFormatPlus1 : undefined,
        day: !hasRange ? startFormat : undefined,
        frec: undefined,
        mac,
        meter: id_slave,
        ...extra,
      };
    }

    const query = buildQueryString(queryObj);

    const res = await publicRequest.get(`/data/${endpoint}?${query}`, {
      headers: { token: `Bearer ${token}` },
    });

    let data = res.data;

    if (hasRange && Array.isArray(data) && data.length) {
      const minTs = Date.parse(startDateTime);
      const maxTs = Date.parse(endDateTime);

      const pickTs = (row) => row?.timestamp || row?.date_time;
      const parseTs = (row) => Date.parse(pickTs(row));

      data = data.filter((row) => {
        const ts = parseTs(row);
        return Number.isFinite(ts) && ts >= minTs && ts <= maxTs;
      });

    }
    dispatch(dataSuccess(data));
    return data;
  } catch (error) {
    dispatch(dataFailure());
  }
};
export const getAlldata = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "datainverter", start, end, frec, mac, id_slave);

export const getHumidity = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "humidity", start, end, frec, mac, id_slave);

export const getVFases = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "vfases", start, end, frec, mac, id_slave);

export const getIFases = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "ifases", start, end, frec, mac, id_slave);

export const getFrec = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "frec", start, end, frec, mac, id_slave);

export const getEap = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "eap", start, end, frec, mac, id_slave);

export const getEReal = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "ereal", start, end, frec, mac, id_slave);

export const getFp = (dispatch, token, start, end, frec, mac, id_slave) =>
  fetchData(dispatch, token, "fp", start, end, frec, mac, id_slave);

export const getCorriente = (dispatch, token, start, end, frec, mac, extra, id_slave) =>
  fetchData(dispatch, token, "corriente", start, end, frec, mac, extra, id_slave);

export const getTension = (dispatch, token, start, end, frec, mac, extra, id_slave) =>
  fetchData(dispatch, token, "tension", start, end, frec, mac, extra, id_slave);

export const getPotActiva = (dispatch, token, start, end, frec, mac, extra, id_slave) =>
  fetchData(dispatch, token, "potActiva", start, end, frec, mac, extra, id_slave);

export const getPotReactiva = (
  dispatch,
  token,
  start,
  end,
  frec,
  mac,
  extra,
  id_slave
) => fetchData(dispatch, token, "potReactiva", start, end, frec, mac, extra, id_slave);

export const getEActiva = (dispatch, token, start, end, frec, mac, extra, id_slave) =>
  fetchData(dispatch, token, "eActiva", start, end, frec, mac, extra, id_slave);

export const getEReactiva = (dispatch, token, start, end, frec, mac, extra, id_slave) =>
  fetchData(dispatch, token, "eReactiva", start, end, frec, mac, extra, id_slave);

export const getCalculatedParameter = (
  dispatch,
  token,
  start,
  end,
  frec,
  mac,
  id_calculated_parameter
) =>
  fetchData(dispatch, token, "calculatedparameter", start, end, frec, mac, {
    idparameter: id_calculated_parameter,
  });

export const getMeGroups = async (dispatch, token) => {
  try {
    const res = await publicRequest.get(`/data/megroups`, {
      headers: { token: `Bearer ${token}` },
    });
    dispatch(measurementGroupsSuccess(res.data));
  } catch (error) {
    return error;
  }
};
